import React from "react";

// The Debii "d-leaf" mark, rendered inline as SVG for crisp low-bandwidth loading.
export function LogoMark({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <rect width="100" height="100" rx="26" fill="#0D4736" />
      <path
        d="M62 26c0 20-14 30-27 30-8 0-13-5-13-12 0-9 8-15 18-15 6 0 10 2 13 5V26z"
        fill="#FFFFFF"
      />
      <path
        d="M40 44c0 16 8 30 22 30 8 0 15-6 15-16 0-13-10-22-24-22-5 0-9 1-13 3v5z"
        fill="#FFFFFF"
        opacity="0.0"
      />
      <path
        d="M63 22c6-2 13 1 15 7-6 2-13-1-15-7z"
        fill="#34D399"
      />
      <path
        d="M35 70c-8 0-13-6-13-14V40c4 2 8 3 13 3 12 0 22 8 22 20 0 4-2 7-5 7H35z"
        fill="#FFFFFF"
        opacity="0.92"
      />
    </svg>
  );
}

export function Logo({ size = 40, showWordmark = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      {showWordmark && (
        <span
          className="font-display font-extrabold tracking-tight text-primary"
          style={{ fontSize: size * 0.7 }}
        >
          Debii
        </span>
      )}
    </div>
  );
}
